import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-display text-xl font-bold text-background-50 mb-4">
              韩漫大全
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              韩国漫画无删减漫画下拉式免费韩漫大全平台，致力于为中文读者提供最优质的韩国漫画阅读体验，资源丰富多元且无广告干扰。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors">全部漫画</Link></li>
              <li><Link to="/category/romance" className="text-sm text-background-400 hover:text-primary-400 transition-colors">恋爱漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-background-400 hover:text-primary-400 transition-colors">奇幻漫画</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              平台特色
            </h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-400"></i> 无删减原版内容
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-400"></i> 下拉式流畅阅读
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-400"></i> 免费韩漫大全
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-400"></i> 纯净无广告体验
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 韩漫大全 - 韩国漫画无删减下拉式免费阅读平台 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="/about" className="hover:text-primary-400 transition-colors">联系我们</a>
            <span>|</span>
            <a href="/about" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <span>|</span>
            <a href="/about" className="hover:text-primary-400 transition-colors">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}